
export enum BeaconSourceCd {
	INSPECTIONS = 'Inspections',
	LINEHAUL = 'Linehaul',
	PICKUP_REQUEST = 'PickupRequest',
	PN_D = 'PnD',
	RADAR = 'Radar'}

